// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noPhotosBlock__Ix8Xn {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 380px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 20px;
  background-color: var(--tables-photo-gallery-surface);
}
@media (max-width: 999px) {
  .noPhotosBlock__Ix8Xn {
    min-height: 180px;
    max-height: 200px;
    row-gap: 10px;
  }
}

.noPhotosIcon__NvasV {
  width: 110px;
  height: 110px;
  padding: 13px 10px;
}
@media (max-width: 999px) {
  .noPhotosIcon__NvasV {
    width: 70px;
    height: 70px;
  }
}

.textWrapper__qfPyl {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.blockTitle__uYi2N {
  color: var(--tables-secondary-row-sub-title-text);
  margin-bottom: 4px;
}

.blockDescr__PNWRt {
  color: var(--tables-primary-row-text-additional);
  letter-spacing: 0.11px;
  margin-bottom: 19px;
}
@media (max-width: 999px) {
  .blockDescr__PNWRt {
    margin-bottom: 9px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Gallery/components/EmptyGalleryBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,qDAAA;AAzEF;AA2EE;EAhBF;IAiBI,iBAAA;IACA,iBAAA;IACA,aAAA;EAxEF;AACF;;AA2EA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAxEF;AA0EE;EALF;IAMI,WAAA;IACA,YAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAvEF;;AA0EA;EACE,iDAAA;EACA,kBAAA;AAvEF;;AA0EA;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;AAvEF;AAyEE;EALF;IAMI,kBAAA;EAtEF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.noPhotosBlock {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  min-height: 380px;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  row-gap: 20px;\n  background-color: var(--tables-photo-gallery-surface);\n\n  @media (max-width: 999px) {\n    min-height: 180px;\n    max-height: 200px;\n    row-gap: 10px;\n  }\n}\n\n.noPhotosIcon {\n  width: 110px;\n  height: 110px;\n  padding: 13px 10px;\n\n  @media (max-width: 999px) {\n    width: 70px;\n    height: 70px;\n  }\n}\n\n.textWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.blockTitle {\n  color: var(--tables-secondary-row-sub-title-text);\n  margin-bottom: 4px;\n}\n\n.blockDescr {\n  color: var(--tables-primary-row-text-additional);\n  letter-spacing: 0.11px;\n  margin-bottom: 19px;\n\n  @media (max-width: 999px) {\n    margin-bottom: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noPhotosBlock": `noPhotosBlock__Ix8Xn`,
	"noPhotosIcon": `noPhotosIcon__NvasV`,
	"textWrapper": `textWrapper__qfPyl`,
	"blockTitle": `blockTitle__uYi2N`,
	"blockDescr": `blockDescr__PNWRt`
};
module.exports = ___CSS_LOADER_EXPORT___;
